module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stil-overview d-timetal__container"
  }, [_c('h4', {
    staticClass: "uppercase"
  }, [_vm._v("Personale")]), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.stilDataRess), function(userType, idx) {
    return _c('tr', {
      key: userType.id
    }, [_c('td', [_vm._v(_vm._s(userType.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.number_of_usertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.years_of_work))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_B))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_B))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A22))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A22))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_40_A33))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userType.stil_hours_50_A33))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "center"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "225px"
    },
    attrs: {
      "rowspan": "2"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Antal personer")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Årsværk")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Arbejdstimer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Fagopdelt undervisning")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Understøttende undervisning")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Øvrig tid med eleverne")])]), _vm._v(" "), _c('tr', {
    staticClass: "thead-second-row"
  }, [_c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")]), _vm._v(" "), _c('th', [_vm._v("Normalklasser")]), _vm._v(" "), _c('th', [_vm._v("Specialklasser")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dab03e6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetningRessourceOverview.vue
// module id = 2137
// module chunks = 1